interface Contacts {
  address: string;
  calendly: string;
  github: string;
  email: string;
  linkedin: string;
  linktree: string;
  pec: string;
  phoneNumber: string;
  phoneNumberHref: string;
  sdl: string;
  telegram: string;
  tiktok: string;
  mastodon: string;
  vat: string;
  whatsapp: string;
}

const CONTACTS: Contacts = {
  address: 'Via Antonio Marangoni 33, 33100, Udine (UD)',
  calendly: 'https://calendly.com/veeso-dev',
  email: 'christian.visintin@veeso.dev',
  github: 'https://github.com/veeso',
  linkedin: 'https://www.linkedin.com/in/christian-visintin/',
  linktree: 'https://linktr.ee/veeso',
  pec: 'christian.visintin@pec.fiscozen.it',
  phoneNumber: '+39 379 261 5635',
  phoneNumberHref: 'tel:+393792615635',
  sdl: '3C984HL',
  telegram: 'https://t.me/veeso_dev',
  tiktok: 'https://www.tiktok.com/@veeso97',
  mastodon: 'https://hachyderm.io/@veeso_dev',
  vat: 'IT03104140300',
  whatsapp: 'https://wa.me/message/BQGR4AO6YI7GE1',
};

export default CONTACTS;
